import { render, staticRenderFns } from "./EstablishmentEditTabAccount.vue?vue&type=template&id=161fa02d&"
import script from "./EstablishmentEditTabAccount.vue?vue&type=script&lang=js&"
export * from "./EstablishmentEditTabAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports